/**
 * Sorting related constants
 */

export const SORT_DIRECTIONS = {
  ASC: "asc",
  DESC: "desc",
} as const;

export const FIELD_TYPES = {
  DATE: "date",
  NUMBER: "number",
  STRING: "string",
  ARRAY_LENGTH: "array_length",
} as const;

export const DEFAULT_VALUES = {
  SORT_DIRECTION: SORT_DIRECTIONS.ASC,
} as const;
